import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../services/auth/auth.service';
import { Routes } from '../../../app-routing.models';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.$isAuthorized.pipe(
      map((isAuthorized) => {
        if (isAuthorized) {
          return true;
        }

        this.router.navigate([Routes.SignIn]);

        return false;
      }),
    );
  }
}
